import { baseFetchToken } from './BaseSaga'
import WarehouseActions from '../Redux/WarehouseRedux'
import { getToken } from '../Services/GetToken'

export function * getWarehouse (api, action) {
  yield baseFetchToken(
    api.getWarehouse,
    action.data,
    getToken,
    WarehouseActions.getWarehouseSuccess,
    WarehouseActions.getWarehouseFailure
  )
}

export function * createWarehouse (api, action) {
  yield baseFetchToken(
    api.createWarehouse,
    action.data,
    getToken,
    WarehouseActions.createWarehouseSuccess,
    WarehouseActions.createWarehouseFailure
  )
}

export function * updateWarehouse (api, action) {
  yield baseFetchToken(
    api.updateWarehouse,
    action.data,
    getToken,
    WarehouseActions.updateWarehouseSuccess,
    WarehouseActions.updateWarehouseFailure
  )
}

export function * deleteWarehouse (api, action) {
  yield baseFetchToken(
    api.deleteWarehouse,
    action.data,
    getToken,
    WarehouseActions.deleteWarehouseSuccess,
    WarehouseActions.deleteWarehouseFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/WarehouseSagas.js